import { execSync } from 'child_process';

export const logVersionMetadata = (): void => {
  let version: string = '__LOCAL__';
  let hash: string = '__LOCAL__';

  // If version is not "__LOCAL__," get it from npm package
  if (version === '__LOCAL__') {
    version = process.env.npm_package_version || '__LOCAL__';
  }

  // If hash is not "__LOCAL__," get it from Git. Guarded because this runs
  // first in the Wopee constructor, and an unpacked template is not a git
  // checkout — an unhandled git error here would mask the real configuration
  // problem the user needs to see.
  if (hash === '__LOCAL__') {
    try {
      hash = execSync('git rev-parse HEAD', { stdio: ['ignore', 'pipe', 'ignore'] })
        .toString()
        .trim();
      const status = execSync('git status --porcelain', { stdio: ['ignore', 'pipe', 'ignore'] })
        .toString()
        .trim();
      if (status) {
        hash = `${hash}: ${status.split('\n').join(', ')}`;
      }
    } catch {
      hash = '__LOCAL__';
    }
  }

  console.log('info', `Initializing Wopee's Playwright integration: version(${version}), hash(${hash})`);
};
